import React, { useEffect } from "react";
import "./theme.scss";

const Theme = () => {
  useEffect(() => {
    const toggleSwitch = document.querySelector('.theme-switch input[type="checkbox"]');
    const currentTheme = localStorage.getItem('theme');

    if (currentTheme) {
      document.documentElement.setAttribute('data-theme', currentTheme);

      if (currentTheme === 'dark' && toggleSwitch) {
        toggleSwitch.checked = true;
      }
    }

    const switchTheme = (e) => {
      const target = e.target;
      if (target.checked) {
        document.documentElement.setAttribute('data-theme', 'dark');
        localStorage.setItem('theme', 'dark');
      } else {
        document.documentElement.setAttribute('data-theme', 'light');
        localStorage.setItem('theme', 'light');
      }
    };

    if (toggleSwitch) {
      toggleSwitch.addEventListener('change', switchTheme, false);
    }

    // Cleanup event listener on component unmount
    return () => {
      if (toggleSwitch) {
        toggleSwitch.removeEventListener('change', switchTheme, false);
      }
    };
  }, []);

  const handleKeyDown = (e) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault(); // Prevent default scrolling behavior for Space
      const input = e.currentTarget.querySelector('input[type="checkbox"]');
      if (input) {
        input.checked = !input.checked; // Toggle the checkbox state
        input.dispatchEvent(new Event("change", { bubbles: true })); // Trigger the change event
      }
    }
  };

  return (
    <div className="theme-switch-wrapper">
      <label className="theme-switch" htmlFor="checkbox" onKeyDown={handleKeyDown} tabIndex={0}>
        <input
          type="checkbox"
          id="checkbox"
        />
        <div className="slider round"></div>
      </label>
      <span>Dark Mode</span>
    </div>
  );
};

export default Theme;